import { Dayjs } from "dayjs";
import { EmployeeRoles } from "../Employees/EmployeeRoles";

export interface ProjectProductsSourcingVariants {
  order_id: number;
  product_id: number;
  product_name: string;
  variants: string;
  printing_type: string;
  quantity: number;
}

export interface SendEmailerPopupInfo {
  type: ProjectEmailerType;
  title: string;
  message: string;
  permissions: EmployeeRoles[];
}

export interface ProjectHandoverData {
  id?: number;
  order_id?: number;
  log_files_required?: number;
  log_files_received?: number;
  size_mix_files_required?: number;
  size_mix_files_received?: number;
  insert_content_required?: number;
  insert_content_received?: number;
  address_file_required?: number;
  address_file_received?: number;
  expected_dispatch_date?: Date | Dayjs | string;
  emails_count?: number;
  email_sent?: number;
  email_sent_by?: number;
  email_sent_by_name?: string;
  email_sent_date?: Date;
  products: ProjectProductsSourcingVariants[];
  created_by?: number;
  created_by_name?: string;
  updated_by?: number;
  updated_by_name?: string;
  created_date?: Date;
  modified_date?: Date;
}

export interface ProjectEmailerInfo {
  id?: number;
  order_id?: number;
  type: ProjectEmailerType;
  preview_email_sent?: number;
  preview_email_sent_date?: Date;
  preview_email_sent_by?: number;
  preview_email_sent_by_name?: string;
  emails_count?: number;
  email_sent?: number;
  email_sent_date?: Date;
  email_sent_by?: number;
  email_sent_by_name?: string;
  created_by?: number;
  created_by_name?: string;
  updated_by?: number;
  updated_by_name?: string;
  created_date?: Date;
  modified_date?: Date;
}
export interface ProjectEmailer {
  type: ProjectEmailerType;
  title: string;
  message: string;
  permissions: EmployeeRoles[];
}

export enum ProjectEmailerType {
  HANDOVER_CALL_DETAILS = "HANDOVER_CALL_DETAILS",
  MOCKUPS_APPROVAL_REMINDER = "MOCKUPS_APPROVAL_REMINDER",
  PRODUCTION_BEGINS = "PRODUCTION_BEGINS",
  PRODUCTION_STATUS = "PRODUCTION_STATUS",
  READY_FOR_DISPATCH = "READY_FOR_DISPATCH",
  DISPATCH_DETAILS = "DISPATCH_DETAILS",
  DELIVERY_CONFIRMATION_AND_NPS = "DELIVERY_CONFIRMATION_AND_NPS",
  CSAT = "CSAT",
}

export const project_emailers: ProjectEmailer[] = [
  {
    type: ProjectEmailerType.HANDOVER_CALL_DETAILS,
    title: "Handover Call Details",
    message: "Are you sure you want to send the handover call details email?",
    permissions: [EmployeeRoles.SEND_CLIENT_HANDOVER_EMAILER],
  },
  {
    type: ProjectEmailerType.MOCKUPS_APPROVAL_REMINDER,
    title: "Mockups Approval Reminder",
    message:
      "Are you sure you want to send the mockups approval reminder email?",
    permissions: [EmployeeRoles.SEND_PROJECTS_CLIENT_EMAILER],
  },
  {
    type: ProjectEmailerType.PRODUCTION_BEGINS,
    title: "Production Begins",
    message: "Are you sure you want to send the production begins email?",
    permissions: [EmployeeRoles.SEND_PROJECTS_CLIENT_EMAILER],
  },
  {
    type: ProjectEmailerType.PRODUCTION_STATUS,
    title: "Production Status",
    message: "Are you sure you want to send the production status email?",
    permissions: [EmployeeRoles.SEND_PROJECTS_CLIENT_EMAILER],
  },
  {
    type: ProjectEmailerType.READY_FOR_DISPATCH,
    title: "Ready For Dispatch",
    message: "Are you sure you want to send the ready for dispatch email?",
    permissions: [EmployeeRoles.SEND_PROJECTS_CLIENT_EMAILER],
  },
  {
    type: ProjectEmailerType.DISPATCH_DETAILS,
    title: "Dispatch Details",
    message: "Are you sure you want to send the dispatch details email?",
    permissions: [EmployeeRoles.SEND_PROJECTS_CLIENT_EMAILER],
  },
  {
    type: ProjectEmailerType.DELIVERY_CONFIRMATION_AND_NPS,
    title: "Delivery Confirmation & NPS",
    message:
      "Are you sure you want to send the delivery confirmation & NPS email?",
    permissions: [EmployeeRoles.SEND_PROJECTS_CLIENT_EMAILER],
  },
];
